import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itk-subnav',
  templateUrl: './subnav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItkSubnavComponent {}
